import Marquee from 'react-fast-marquee';
import { CLIENTS } from '@/constants/testIds';

const clients = [
  { name: 'HKT', src: '/assets/img/HKT.jpg' },
  { name: 'Oracle', src: '/assets/img/oracle.jpg' },
  { name: 'HKBN', src: '/assets/img/hongkong.jpeg' },
  { name: 'Jio', src: '/assets/img/jio.jpg' },
  { name: 'Hathway', src: '/assets/img/hathway.jpg' },
  { name: 'Digi', src: '/assets/img/digi.jpg' },
  { name: 'Equiniti', src: '/assets/img/equi.jpg' },
  { name: 'Rackspace', src: '/assets/img/rackspace.jpg' },
];

const ClientsMarquee = () => {
  return (
    <section data-testid={CLIENTS.section} className="py-12 border-y border-white/5 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-6">
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-slate-400 text-center">
          Trusted by industry leaders
        </p>
      </div>
      <Marquee
        data-testid={CLIENTS.marquee}
        speed={40}
        gradient={true}
        gradientColor="#ffffff"
        gradientWidth={60}
        pauseOnHover
      >
        {clients.map((client) => (
          <div key={client.name} className="mx-10 md:mx-14 flex items-center justify-center" data-testid={`client-${client.name.toLowerCase()}`}>
            <img
              src={client.src}
              alt={client.name}
              className="h-14 md:h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default ClientsMarquee;
